const BASE_URL =
  process.env.REACT_APP_NODE_ENV === 'development'
    ? 'https://murettebat-api.chargesoft.co/' //'http://34.253.17.25:8080/'
    : 'https://murettebat-api.chargesoft.co/';
export const SERVER_URL = `${BASE_URL}admin/api/0.0/`;
export const MOBILE_URL = `${BASE_URL}api/0.0/`;
export const APP_VERSION = '1.0';
export const OTOPARLAK_LOGO =
  'https://www.chargesoft.co/wp-content/uploads//2021/04/white.svg';
